import * as api from "../../services/staff-service";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const addAdmin = createAsyncThunk("CREATE_ADMIN", async (payload) => {
  const response = await api.addAdmin(payload);
  return response;
});

// Admin account management. Callers unwrap() these and handle the result, so
// the staff page can refresh its list instead of reloading.
export const fetchAdminAccount = createAsyncThunk(
  "FETCH_ADMIN_ACCOUNT",
  (id) => api.getAdminAccount(id)
);
export const updateAdminRole = createAsyncThunk(
  "UPDATE_ADMIN_ROLE",
  (payload) => api.updateAdminRole(payload)
);
export const resetAdminPassword = createAsyncThunk(
  "RESET_ADMIN_PASSWORD",
  (id) => api.resetAdminPassword(id)
);
export const setAdminStatus = createAsyncThunk(
  "SET_ADMIN_STATUS",
  (payload) => api.setAdminStatus(payload)
);
export const deleteAccount = createAsyncThunk("DELETE_ACCOUNT", (id) =>
  api.deleteAccount(id)
);

export const allStaff = createAsyncThunk("FETCH_STAFF", async (payload) => {
  const response = await api.getAllStaff();
  return response;
});
